import { Injectable, signal } from '@angular/core'

@Injectable()
export class PanelService {
  isOpen$ = signal<boolean>(false)

  togglePanel() {
    this.isOpen$.set(!this.isOpen$())
  }

  openPanel() {
    this.isOpen$.set(true)
  }

  closePanel() {
    this.isOpen$.set(false)
  }
}
